import { Component, OnInit, TemplateRef } from '@angular/core';
import { ContentService } from '../../shared/content.service';

import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-anthem demo-modal-sizes',
  templateUrl: './anthem.component.html',
  styleUrls: ['./anthem.component.scss']
})
export class AnthemComponent implements OnInit {

  page: Object;
  
  constructor(private contentService: ContentService, private modalService: BsModalService) { 
  }

  ngOnInit() {
    this.page = this.contentService.pages['anthem'];
  }

  modalRef: BsModalRef;
 
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: 'static',
      class: 'modal-fluid'
    });
  }
}